var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rect',{attrs:{"y":"130","width":"300","height":"44"}})}
var staticRenderFns = []

export { render, staticRenderFns }